import { connect } from 'react-redux';

import withDeleteModal from '../hoc/withDeleteModal';

import { deleteIdea as deleteIdeaApi } from 'api/ideas/deleteIdea';
import { deleteIdea } from 'actions/idea';

const mapDispatchToProps = (dispatch) => {
  return {
    reduxRemover: (ideaId) => dispatch(deleteIdea(ideaId)),
  };
};

// The shared withDeleteModal HOC drives the same confirm/cancel UI the
// DeletePostModal uses. `itemToDelete` is the bare idea _id string —
// `deleteIdeaApi` shapes it into a DELETE /ideas/:id URL.
const DeleteIdeaModal = withDeleteModal({
  itemLabel: 'idea',
  request: deleteIdeaApi,
});

export default connect(() => ({}), mapDispatchToProps)(DeleteIdeaModal);
